import { render, staticRenderFns } from "./ModalTexto.vue?vue&type=template&id=f92e71f0&scoped=true&"
import script from "./ModalTexto.vue?vue&type=script&lang=js&"
export * from "./ModalTexto.vue?vue&type=script&lang=js&"
import style0 from "./ModalTexto.vue?vue&type=style&index=0&id=f92e71f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92e71f0",
  null
  
)

export default component.exports